.container {
    display: flex;
    flex-direction: row-reverse;
    gap: 8px;
    padding-inline: 24px;
    padding-block: 8px;
    border-top: var(--border from global);
}